export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/email_copy.12afa19.svg";